var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternalNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M1.915 0h24.89c1.409 0 2.552 1.144 2.552 2.553v18.508c0 1.057-.857 1.915-1.914 1.915h-15.51l-5.092 4.608c-.399.412-1.097.13-1.097-.443v-4.165H1.915C.857 22.976 0 22.118 0 21.061V1.915C0 .857.857 0 1.915 0",
    transform: "translate(-364 -493) translate(365.543 493.854)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6B696A",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M1.915 0h24.89c1.409 0 2.552 1.144 2.552 2.553v18.508c0 1.057-.857 1.915-1.914 1.915h-15.51l-5.092 4.608c-.399.412-1.097.13-1.097-.443v-4.165H1.915C.857 22.976 0 22.118 0 21.061V1.915C0 .857.857 0 1.915 0z",
    transform: "translate(-364 -493) translate(365.543 493.854)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M0.5 0L0.5 1.276",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(14.179 3.191)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M0.5 0L0.5 1.276",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(14.179 3.191)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M3.829 0c0 .705-.857 1.276-1.915 1.276C.857 1.276 0 .705 0 0",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(12.764 18.508)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M3.829 0c0 .705-.857 1.276-1.915 1.276C.857 1.276 0 .705 0 0",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(12.764 18.508)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M19.146 10.85V8.935c0-2.467-2-4.467-4.467-4.467-2.468 0-4.468 2-4.468 4.467v1.915c0 1.915-.381 3.983-1.914 5.105v1.277h12.764v-1.277c-1.533-1.122-1.915-3.19-1.915-5.105",
    transform: "translate(-364 -493) translate(365.543 493.854)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M19.146 10.85V8.935c0-2.467-2-4.467-4.467-4.467-2.468 0-4.468 2-4.468 4.467v1.915c0 1.915-.381 3.983-1.914 5.105v1.277h12.764v-1.277c-1.533-1.122-1.915-3.19-1.915-5.105z",
    transform: "translate(-364 -493) translate(365.543 493.854)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M1.548 0c-2.064 2.061-2.064 5.401 0 7.462",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(3.83 6.161)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M1.548 0c-2.064 2.061-2.064 5.401 0 7.462",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(3.83 6.161)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M.82 0c-.852.772-.852 2.025 0 2.798",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(6.84 8.493)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M.82 0c-.852.772-.852 2.025 0 2.798",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(6.84 8.493)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M0 0c2.063 2.061 2.063 5.401 0 7.462",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(23.98 6.161)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M0 0c2.063 2.061 2.063 5.401 0 7.462",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(23.98 6.161)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M.18 0c.852.772.852 2.025 0 2.798",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(21.518 8.493)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M.18 0c.852.772.852 2.025 0 2.798",
    transform: "translate(-364 -493) translate(365.543 493.854) translate(21.518 8.493)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalNotification);
export default __webpack_public_path__ + "static/media/external_notification.845241f12c5125a9d114e9ed336b8e64.svg";
export { ForwardRef as ReactComponent };